
import { defineComponent, ref, onMounted } from "vue";
import ApiService from "@/core/services/ApiService";
import { useStore } from "vuex";

export default defineComponent({
  name: "merchant-applications",
  components: {},
  setup() {
    const loading = ref(false);
    const applicationFiles = ref([]);
    const applicationFilesTotal = ref(0);
    const store = useStore();

    onMounted(() => {
      setTimeout(() => {
        getApplicationFiles();
      }, 1000);
    });
    const getApplicationFiles = async () => {
      loading.value = true;
      const res2 = await ApiService.get(
        `img/app.center?ibo_id=${store.getters.currentUser.data.adminid}`
      );
      applicationFiles.value = res2.data.data;
      applicationFilesTotal.value = res2.data.meta.total;

      loading.value = false;
    };
    return {
      applicationFiles,
      applicationFilesTotal,
    };
  },
});
